<template>
  <div class="autohw" v-if="items.length > 0">
    <h3>Шаблоны автоматического ДЗ</h3>
    <ul class="uk-child-width-1-1@s uk-grid-match uk-grid-small" uk-grid>
      <li v-for="(item, k) in items" :key="item.id">
        <AutoHomeworkItem :item="item" :date="k" :key="item.id" />
      </li>
    </ul>
  </div>
</template>

<script>
import AutoHomeworkItem from "./AutoHomeworkItem";
import { mapGetters } from 'vuex'

export default {
  name: "AutoHomeworkItems",
  inject: ['http'],
  components: {
    AutoHomeworkItem
  },
  props: {
    class_id: '',
    item: ''
  },
  computed: {
    ...mapGetters({
      items: 'teacher/templates'
    })    
  }
}
</script>